import { render } from "./PaperUploadIcon.vue?vue&type=template&id=0db172c4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/PaperUploadIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0db172c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0db172c4', __exports__)) {
    api.reload('0db172c4', __exports__)
  }
  
  module.hot.accept("./PaperUploadIcon.vue?vue&type=template&id=0db172c4", () => {
    api.rerender('0db172c4', render)
  })

}


export default __exports__